import React from 'react';
import {Col, Container, Row} from "react-bootstrap";

function Whychoose(props) {
    return (
        <section className=" tekrevol_dark_bg p-100">
            <Container>
                <Row>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                        <div className="example" data-text="Development">
                            <h2>Robust, Cross-Functional & Easy-To-Implement Solutions: Python Development Services For Hire</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                        <p>Python is a rich, easy-to-implement, and powerful programming language. Its easy-to-use and understandable concepts make it the ultimate choice for many development initiatives. TekRevol is a Python development services provider that utilizes the language to build custom web solutions for your business and its IT goals. Hire Python developers today to get the best development services.</p>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default Whychoose;